module.exports = __webpack_public_path__ + "static/media/3.e3e69dc6.png";